<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPageLoader"
      :color="loaderColor"
    ></loading>
    <v-wait for="integrations">
      <half-circle-spinner
        slot="waiting"
        style="display: block; margin: 0 auto"
        :animation-duration="1000"
        :size="60"
        color="#3d4852"
      />
      <div class="flex">
        <vertical-tabs
          :tabs="storageSettingsTabs"
          :currentTab="storageSettingsTab"
          :wrapper-class="'pt-5 tab-width border-r border-grey-200 pb-10'"
          @onClick="handleStorageTabChange"
        />
        <div class="p-5 w-full">
          <div v-if="storageSettingsTab === 'encoding'">
            <encoder-settings
              :encodingAccounts="encodingAccounts"
              @setIsLoading="isLoading = $event"
            >
            </encoder-settings>
          </div>
          <div v-else>
            <storage-settings
              :storageAccounts="storageAccounts"
              @setIsLoading="isLoading = $event"
              :totalStorage="totalStorage"
              :storageUsed="storageUsed"
              :storageSettingsTab="storageSettingsTab"
            >
            </storage-settings>
          </div>
        </div>
      </div>
    </v-wait>
  </div>
</template>
<script>
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import themeConfig from './theme/themeConfig.js';
import 'vue-loading-overlay/dist/vue-loading.css';
import Storage from './models/Storage';
import Encoder from './models/Encoder';
import StorageSettings from './storageSettings';
import EncoderSettings from './encoderSettings';
import VerticalTabs from './components/VerticalTabs';
import auth from '@groovepages/gd-lib/auth';

export default {
  middleware: 'auth',
  components: {
    Loading,
    StorageSettings,
    EncoderSettings,
    VerticalTabs
  },
  data () {
    return {
      isLoading: false,
      fullPageLoader: true,
      loaderColor: themeConfig.appPrimaryColor,
      storageSettingsTab: 'ownStorage',
      totalStorage: 100,
      storageUsed: 0,
      storageAccounts: [],
      encodingAccounts: [],
    };
  },
  computed: {
    canUseStorage () {
      return parseInt(auth.fetchFeatureValue('groovevideo_can_use_groove_storage'), 10) ?? 0;
    },
    storageSettingsTabs () {
      const tabs = [
        {
          title: this.$t(
            'frontend_groovevideo_members_settings_index_groove_storage_settings'
          ),
          value: 'grooveStorage',
        },
        {
          title: this.$t(
            'frontend_groovevideo_members_settings_index_personal_storage_settings'
          ),
          value: 'ownStorage',
        },
        {
          title: this.$t(
            'frontend_groovevideo_members_settings_index_video_encoder'
          ),
          value: 'encoding',
        },
      ];
      if(this.canUseStorage === 0) {
        tabs.shift();
      }
      return tabs;
    },
  },
  async created() {
    this.$wait.start('integrations');
    this.storageAccounts = await Storage.$get();
    this.encodingAccounts = await Encoder.$get();

    if (this.$route.hash !== '') {
      const hash = this.$route.hash.split('#').join('');
      const tabs = this.storageSettingsTabs.map(el => el.value);
      this.storageSettingsTab = tabs.includes(hash) ? hash : tabs[0];
    }
      
    if (this.$store.getters.canUseStorage !== 0) {
      this.storageSettingsTab = this.$route.hash === '' ? 'ownStorage' : this.storageSettingsTab;
      const mainAppUrl = `${window.config.apiUrl.split('/api')[0]}/api`;
      const remainingData = await axios.get(`${mainAppUrl}/groovevideo/remaining`);
      let remaining = 0;
      
      if (remainingData && remainingData.data && remainingData.data.data) {
        // Convert Bytes to GB
        remaining = (remainingData.data.data.res / 1000000000);
      }
      this.totalStorage = Math.floor((this.$store.getters.maxStorage / 1000000000));

      // Calculate storage used to 2nd place of demical.
      this.storageUsed = (this.totalStorage - remaining).toFixed(2);
    }
    this.$wait.end('integrations');
  },
  methods: {
    handleStorageTabChange(newTab) {
      this.storageSettingsTab = newTab;
    },
  },
};
</script>
<style>
.settingstabHead {
  width: 100%;
  display: inline-block;
  border-bottom: 1px solid #f7f7fa;
}
.settingstabHead .tabs__item {
  padding: 15px 20px;
}
.settingstabHead .tabs__item:active,
.settingstabHead .tabs__item:focus {
  outline: none;
}
</style>
<style scoped>
.tab-width {
  width: 27%;
}
</style>